import { useState, useEffect } from 'react';
import { HVARiskElementsTable } from 'components/tables/HVARiskElementsTable';
import {
  fetchHVARiskElements,
  fetchHVARiskCategories,
  HVARiskElement,
  HVARiskCategory
} from 'services/hvarisk.service';

const RiskElementList: React.FC = () => {
  const [elements, setElements] = useState<HVARiskElement[]>([]);
  const [categories, setCategories] = useState<HVARiskCategory[]>([]);

  const loadData = async (): Promise<void> => {
    try {
      const [fetchedElements, fetchedCategories] = await Promise.all([
        fetchHVARiskElements(),
        fetchHVARiskCategories()
      ]);
      setElements(fetchedElements);
      setCategories(fetchedCategories);
    } catch (error) {
      console.error('Error loading risk data:', error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <HVARiskElementsTable
          elements={elements}
          categories={categories}
          onElementsChange={loadData}
        />
      </div>
    </div>
  );
};

export default RiskElementList;
